import { render, staticRenderFns } from "./zMenuImpressoes.vue?vue&type=template&id=1565934e&scoped=true&"
import script from "./zMenuImpressoes.vue?vue&type=script&lang=js&"
export * from "./zMenuImpressoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1565934e",
  null
  
)

export default component.exports